/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateSerieLangRequestViewModel } from "../types/UpdateSerieLangRequestViewModel.ts";

export const updateSerieLangRequestViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe("Código do idioma (cultura) da tradução.")
    .nullish(),
  title: z.string().describe("Título da série neste idioma.").nullish(),
  resumee: z
    .string()
    .describe("Resumo da série neste idioma. Opcional.")
    .nullish(),
  header: z
    .string()
    .describe("Cabeçalho da série neste idioma. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdateSerieLangRequestViewModel>;
